import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import { BizDevelopmentDashboardMobileEndPointLogic } from "../../../../logic/BizDevelopment/Dashboard/BizDevelopmentDashboardMobileEndPointLogic";
import { setMobileComparisonQueryOutput, setMobileComparisonFetchedFor } from "../../../../features/bizDevelopmentDashboardMobileSlice";
import store from "../../../../store";

export const useBizDevelopmentDashboardMobile = () => {
  const [searchParams] = useSearchParams();
  const userData = useSelector(selectUserData);
  const oauthTokenHeader = userData?.data?.oauth_token;

  const getSiteFromWorkspace = (): string[] => {
    const workspaceId = searchParams.get("workspace");
    return workspaceId ? workspaceId.split(",").filter(Boolean) : [];
  };

  const getTimeframeFromParams = (): string => {
    return searchParams.get("timeframePerformance") || "yesterday";
  };

  const fetchDashboardData = async (
    timeframe?: string,
    siteSharedUids?: string[],
  ) => {
    const resolvedTimeframe = timeframe ?? getTimeframeFromParams();
    const resolvedSites = siteSharedUids ?? getSiteFromWorkspace();
    if (resolvedSites.length === 0) return;

    await BizDevelopmentDashboardMobileEndPointLogic.getDashboardData(
      oauthTokenHeader,
      resolvedSites,
      resolvedTimeframe,
    );
  };

  const fetchComparisonData = async (
    timeframe: string,
    siteSharedUids?: string[],
  ) => {
    const resolvedSites = siteSharedUids ?? getSiteFromWorkspace();
    if (resolvedSites.length === 0) return;

    await BizDevelopmentDashboardMobileEndPointLogic.getComparisonDashboardData(
      oauthTokenHeader,
      resolvedSites,
      timeframe,
    );
  };

  const clearComparisonData = () => {
    store.dispatch(setMobileComparisonQueryOutput([]));
    store.dispatch(setMobileComparisonFetchedFor(null));
  };

  return {
    fetchDashboardData,
    fetchComparisonData,
    clearComparisonData,
    getSiteFromWorkspace,
    getTimeframeFromParams,
  };
};
